import { useFormik, Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import React,{ setstate,useState } from 'react'
import './MainContentAreaAll.css';
// const validateProduct = Data => {
//     const errors = {};
  
//     if (!Data.ProuctName) {
//       errors.ProuctName = 'Please Enter Product Name';
//     } else if (Data.ProuctName.length > 20) {
//       errors.ProuctName = 'Name cannot exceed 20 characters';
//     }
  
//     if (!Data.ProductPurchasePrize) {
//       errors.ProductPurchasePrize = 'Please Enter ProductPurchasePrize';
//     } else if(isNaN(Data.ProductPurchasePrize)){
//         errors.ProductPurchasePrize = "Please Enter a Valid Prize"
//     }
  
//     if (!Data.ProductQuantity) {
//       errors.ProductQuantity = 'Please Enter Product Quantity';
//     } else if (isNaN(Data.ProductQuantity)) {
//       errors.ProductQuantity = "Please Enter a Valid Quantity";
//     }
  
//     return errors;
//   };
const FormEXComponent =() =>{
    const [Success, setSuccess] = useState({Success:'',res:''})
    // const formik = useFormik({
    //     initialValues: {
    //         ProductName:'',
    //         ProductPurchasePrize:'',
    //         ProductQuantity:''
    //     },
    //      // validate:validateProduct,
    //      validationSchema: yup.object({

    //         ProductName: yup.string()
      
    //           .max(20, 'ProuctName should not exceed 20 Characters')
      
    //           .required('Please Enter Employee Name'),
      
    //           ProductPurchasePrize: yup.number().typeError("Invalid number")
      
    //           .required('Please Enter ProductPurchasePrize'),
      
    //           ProductQuantity: yup.number().typeError("Invalid number")
                  
    //           .required('Please Enter ProductQuantity'),
      
    //       }),
    //     onSubmit: values => {
    //       alert(JSON.stringify(values));
    //     },
    //   });
    // return(
    //     <div>              
    //             <h2>Enter Product Details...</h2>
    //             <form onSubmit={formik.handleSubmit}>
    //             <p>
    //             <label htmlFor="ProductName">ProductName : </label>
    //             <input   name="ProductName" { ...formik.getFieldProps("ProductName")} onBlur={formik.handleBlur}
    //                 /> {formik.touched.ProductName && formik.errors.ProductName ? <span style={{color:'red'}}>{formik.errors.ProductName}</span> : null}
    //             </p>
    //                 <p>
    //                 <label htmlFor="ProductPurchasePrize">Product Prize :</label>
    //                 <input
    //                     id="ProductPurchasePrize"
    //                     name="ProductPurchasePrize" { ...formik.getFieldProps("ProductPurchasePrize")} onBlur={formik.handleBlur}
    //                         />{formik.touched.ProductPurchasePrize && formik.errors.ProductPurchasePrize ? <span style={{color:'red'}}>{formik.errors.ProductPurchasePrize}</span> : null}
    //                 </p>
    //                 <p>
    //                 <label htmlFor="ProductQuantity">Prodcut ProductQuantity :</label>
    //                 <input
    //                     id="ProductQuantity"
    //                     name="ProductQuantity"  { ...formik.getFieldProps("ProductQuantity")}
    //                         onBlur={formik.handleBlur}
    //                 />{formik.touched.ProductQuantity && formik.errors.ProductQuantity ? <span style={{color:'red'}}>{formik.errors.ProductQuantity}</span> : null}
    //                 </p>
    //                 <button type="submit">Submit</button>
    //              </form>
    //          </div>
    // )
      return(
          <Formik initialValues={{
            ProductName:'',
            ProductPurchasePrize:'',
            ProductQuantity:''
          }}
          
          validationSchema = { yup.object({

            ProductName: yup.string()
      
              .max(20, 'ProuctName should not exceed 20 Characters')
      
              .required('Please Enter Employee Name'),
      
              ProductPurchasePrize: yup.number().typeError("Invalid number")
      
              .required('Please Enter ProductPurchasePrize'),
      
              ProductQuantity: yup.number().typeError("Invalid number")
                  
              .required('Please Enter ProductQuantity'),
      
          })}
          onSubmit={ values => {
           alert(JSON.stringify(values));
           fetch("https://localhost:44334/api/ProductDetail",{
            method: 'POST',
            headers:{'Content-type':'application/json'},
            body:JSON.stringify(values)
          }).then(r=>r.json()).then(res=>{
             if(res){
                 //this.setState({message:"Practice Detail Added"});
                 setSuccess({...Success,res:res,Success:"Product Added SuccessFully"});
             }
             else{
                setSuccess({...Success,res:res,Success:"There Are Some Error With Processing "});
             }
          })
          }}
          
          >
    {props=>(
          <div>              
                <h2>Enter Product Details...</h2>
                <Form>
                <p>
                <label htmlFor="ProductName">Product Name </label>
                 <Field name="ProductName" type="text"></Field>
                 <span className="alert-danger"><ErrorMessage  name="ProductName"></ErrorMessage></span>
                </p>
                <label htmlFor="ProductPurchasePrize">Product Prize </label>
                 <Field name="ProductPurchasePrize" type="text"></Field>
                 <span className="alert-danger"><ErrorMessage   name="ProductPurchasePrize"></ErrorMessage></span>
                <p>
                <label htmlFor="ProductQuantity">Product quantity </label>
                 <Field name="ProductQuantity" type="text"></Field>
                 <span className="alert-danger"><ErrorMessage   name="ProductQuantity"></ErrorMessage></span>
                    </p>
                    <button type="submit" disabled={props.isValid==false}>Submit</button>
                 </Form>
                 
                    { (Success.res) ? <span className="alert-success">{Success.Success}</span> :               
                    <span className="alert-danger">{Success.Success}</span> }
             </div>
          )
      }
          </Formik>          
      );      
}
// export default class FormEXComponent extends Component 
// {
//     constructor(props){
//         super(props);
//         this.state = {
//           product:{
//             ProuctName:'',
//             ProductPurchasePrize:'',
//             ProductQuantity:''
//           }
//       };
//     }
//     changeHandler = e =>{
//      const name=e.target.name;
//      const value=e.target.value;
//       this.setState({product:{
//         ...this.state.product,
//         [name]:value
//       }})                    
//     }
//     saveInventory=()=>{
//        console.log(this.state.product);
//     }
//     render() 
//         {
//         return (
//             <div> 
            
//                 <p>
//                     <label>Enter Product Name : <input type="text" name="ProuctName" 
//                                                 value={this.state.product.ProuctName} 
//                                                 onChange={this.changeHandler}></input>
//                     </label>
//                 </p> <p>
//                     <label>Enter Product Prize: <input type="text" name="ProductPurchasePrize" 
//                                             value={this.state.product.ProductPurchasePrize} 
//                                             onChange={this.changeHandler}></input>
//                     </label>
//                 </p> <p>
//                     <label>Enter Product Quantity: <input type="text" name="ProductQuantity"
//                                             value={this.state.product.ProductQuantity} 
//                                             onChange={this.changeHandler}></input>
//                     </label>
//                 </p>
                
//                 <button onClick={this.saveInventory}>Save</button>             
                
//             </div>
//         )
        
//     }
// }
export default  FormEXComponent